import React from 'react';
import { Stack, DialogContent, DialogTitle, IconButton, DialogContentText } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import RefreshIcon from '@mui/icons-material/Refresh';
import { green } from '@mui/material/colors';
import Draggable from 'react-draggable';
import { Resizable } from 'react-resizable';
import { useQuery, useMutation } from 'react-fetching-library';
import { DataGridPro, useGridApiRef } from '@mui/x-data-grid-pro';
import { plPL, GridToolbar } from '@mui/x-data-grid';
import { DataGridToolbar } from '../../../components/data-grid/DataGridToolbar';
import 'react-resizable/css/styles.css';

import { getEventSlotsAvailabilityDataAction, getSlotsControlReport } from '../../../services/request';
import { eventSlotsAvailabilityColumns } from '../../../services/column-definitions';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

export const EventSlotsDraggableDialog = props => {
  const { onClose } = props;
  const apiRef = useGridApiRef();
  const [search, setSearch] = React.useState(null);
  const { loading, payload, error, query } = useQuery(getEventSlotsAvailabilityDataAction(search));
  const { mutate } = useMutation(getSlotsControlReport);
  const [height, setHeight] = React.useState(600);
  const [width, setWidth] = React.useState(1700);
  const [slots, setSlots] = React.useState([]);
  const [columns, setColumns] = React.useState(eventSlotsAvailabilityColumns());

  React.useEffect(() => {
    if (!loading && !error) {
      setSlots(payload);
    }
  }, [loading]);

  const handleClose = (e, backdropClick) => {
    if (!backdropClick) {
      onClose();
    }
  };

  const handleRefresh = () => {
    query();
  };

  const searchCallback = search => {
    setSearch(search);
  };

  const handleDownload = async () => {
    const { error: mutateError, payload: mutatePayload } = await mutate({ 'data': apiRef.current.getSortedRows() });
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = 'Kontrola miejsc.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      alert('Nie udało się pobrać');
    }
  };

  return (
    <div style={{ position: 'absolute', zIndex: 99999999, borderRadius: 25 }}>
      <Draggable
        handle="#draggable-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Resizable
          style={{ position: 'absolute' }}
          height={height}
          width={width}
          onResize={(event, data) => {
            setHeight(height + event.movementY);
            setWidth(width + event.movementX);
          }}
        >
          <div style={{ position: 'absolute' }}>
            <DialogTitle style={{ cursor: 'move', backgroundColor: green[100], marginTop: 0, paddingTop: 0 }} id="draggable-dialog-title">
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Stack direction="row">
                  <IconButton color="primary" onClick={handleRefresh}>
                    <RefreshIcon />
                  </IconButton>
                  <IconButton color="primary" onClick={handleDownload}>
                    <FileDownloadIcon />
                  </IconButton>
                </Stack>
                <IconButton color="primary" onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Stack>
            </DialogTitle>
            <DialogContent sx={{ backgroundColor: green[200] }}>
              <DialogContentText height={`${height}px`} width={`${width}px`}>
                <DataGridPro
                  apiRef={apiRef}
                  columns={columns}
                  rows={slots}
                  density="compact"
                  disableColumnMenu={true}
                  autoPageSize={false}
                  autoHeight={true}
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  pagination
                  localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
                  components={{ Toolbar: DataGridToolbar }}
                  componentsProps={{ toolbar: { containerStyle: { backgroundColor: 'transparent' }, searchStyle: { width: '100%' }, filterToolbar: false, columnsToolbar: false, densityToolbar: false, exportToolbar: false, miniView: true, searchCallback } } }
                  disableSelectionOnClick
                  loading={loading}
                  // onSortModelChange={handleSortModelChange}
                />
              </DialogContentText>

            </DialogContent>
          </div>
        </Resizable>
      </Draggable>
    </div>
  );
};
